var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "data-coloringtype": "stroke",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m12 5-8.531 8.531c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C3 14.296 3 14.418 3 14.663V19.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h4.737c.245 0 .367 0 .482-.028a1 1 0 0 0 .29-.12c.1-.061.187-.148.36-.32L19 12m-7-7 .737-.737c.792-.792 1.188-1.188 1.645-1.337a2 2 0 0 1 1.236 0c.457.149.853.545 1.645 1.337l2.474 2.474c.792.792 1.188 1.188 1.337 1.645a2 2 0 0 1 0 1.236c-.149.457-.545.853-1.337 1.645L19 12m-7-7 7 7"
})));
export default SvgEdit;